import { isOwnApiUrl } from './apiOrigins';

/**
 * Whether a request must carry the Firebase token.
 *
 * The rule is the ORIGIN, not the path: every backend of ours gets the token,
 * and nobody else does. This replaces an allowlist of path substrings that only
 * covered a handful of routes and left the rest calling anonymously.
 *
 * Calendar requests are handled by a later branch of the interceptor that adds
 * the Nylas provider token as well — see the note in `apiOrigins.ts`.
 */
export const shouldProtectRoute = (url: string): boolean => isOwnApiUrl(url);
